import { DocumentDeathFilterForm } from 'civil-status/view-models/document-death-list';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesDocumentDeathSearch: DocumentDeathFilterForm = {
  page: 0,
  rowsPerPage: 10,
  orders: {},
  year: '',
  document: '',
  registry: null,
  portion: '',
  serie: '',
  matricola: '',
  surname: '',
  name: '',
  operationYear: '0',
  operationDocument: '0',
  operationRegistry: '0',
  operationPortion: '0',
  operationSerie: '0',
  operationMatricola: '0',
  operationSurname: '0',
  operationName: '0',
};

const PageDocumentDeathSearchInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesDocumentDeathSearch}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageDocumentDeathSearchInitializer.displayName = 'Page search death initializer component';

export default PageDocumentDeathSearchInitializer;
